/* eslint-disable no-console */
import Vue from 'vue';
import VueObserveVisibility from 'vue-observe-visibility';
import NavScroll from 'navscroll';
import App from './App.vue';
import store from '../store';

const node = document.getElementById('vue-commissioning-sheet');

Vue.use(NavScroll);
Vue.use(VueObserveVisibility);

Vue.mixin({
    methods: {
        numericOnly($event) {
            const invalidChars = ['e', 'E'];
            if (invalidChars.includes($event.key)) {
                $event.preventDefault();
            }
        }
    }
})

if (node) {
    new Vue({
        store,
        data: { ...node.dataset },
        render: (h) => h(App),
    }).$mount(node);
}
